import { $t } from "../../../utils/intl";
import { handleTextField } from "../../prefill/helpers";
import { FieldRegistryConfig } from "../../types";
import { fieldsText } from "../fields.text";
import { TextFieldValue } from "../text/text.config";
import { TextFieldControl } from "../text/TextFieldControl/TextFieldControl";

export const recordTitleFieldConfig: FieldRegistryConfig<TextFieldValue> = {
  icon: "record-title",
  control: (props) => (
    <TextFieldControl placeholder={$t(fieldsText.titlePlaceholder)} type="text" {...props} />
  ),
  prefill: handleTextField,
};
